<div class="row">
  <app-section-banner section="rules-alarm" title="Rule" subtitle="" [detail]="details"></app-section-banner>

  @if (alarm) {
    <app-alarm-view [alarm]="alarm"></app-alarm-view>
  }

</div>